<!-- Hero Section -->
<app-navbar></app-navbar>
<section class="banner-section">
  <div class="container">
    <!-- Left Column -->
    <div class="left-column">
      <h1>Développement Application : Solutions Mobiles & Web Innovantes </h1>
      
      <p class="subtitle">Transformez vos idées en applications performantes avec Digital Alchemy, leader du développement d'applications.</p>
      
      <div class="feature-list">
        <div class="feature-item">
          <div class="feature-check">✓</div>
          <p>Applications iOS et Android natives</p>
        </div>
        <div class="feature-item">
          <div class="feature-check">✓</div>
          <p>Développement web et mobile sur mesure</p>
        </div>
        <div class="feature-item">
          <div class="feature-check">✓</div>
          <p>Interface utilisateur moderne et intuitive</p>
        </div>
        <div class="feature-item">
          <div class="feature-check">✓</div>
          <p>Support technique et maintenance inclus</p>
        </div>
      </div>
      
      <div class="platform-ratings">
        <div class="platform-item" *ngFor="let platform of getPlatformRatings()">
          <div class="platform-logo">
            <div [ngStyle]="{'background': platform.color}" 
                 [innerHTML]="platform.logo === 'google' ? 'G' : 
                            platform.logo === 'provenexpert' ? '✓' : 
                            platform.logo === 'clutch' ? 'C' : 'sl'">
            </div>
          </div>
          <div class="platform-name">{{ platform.name }}</div>
          <div class="rating-score">{{ platform.rating }}</div>
          <div class="rating-stars">★★★★★</div>
        </div>
      </div>
    </div>
    
    <!-- Right Column - FORM -->
    <div class="right-column">
      <div class="form-wrapper">
        <h2>Développons votre application ensemble. Demandez votre devis gratuit.</h2>
        
        <!-- Form Steps Indicator -->
        <div class="form-steps">
          <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
            <div class="step-number">1</div>
            <div class="step-label">PROJET</div>
          </div>
          <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
            <div class="step-number">2</div>
            <div class="step-label">DÉTAILS</div>
          </div>
          <div class="step" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
            <div class="step-number">3</div>
            <div class="step-label">CONTACT</div>
          </div>
        </div>
        
        <!-- Success Message Alert -->
        <div *ngIf="submissionSuccess && !submissionError && !isSubmitting" class="success-alert">
          <div class="success-icon">✓</div>
          <div class="success-message">
            <strong>Demande envoyée avec succès!</strong>
            <br>Nous avons bien reçu votre demande de devis. 
            <br>Notre équipe vous contactera dans les 24 heures.
          </div>
        </div>

        <!-- Error Message Alert -->
        <div *ngIf="submissionError" class="error-alert">
          <div class="error-icon">!</div>
          <div class="error-message">{{ submissionError }}</div>
        </div>
        
        <!-- THE MAIN FORM -->
        <form class="contact-form" (ngSubmit)="onSubmit()" #appForm="ngForm" *ngIf="!submissionSuccess">
          
          <!-- Step 1: Project Type -->
          <div *ngIf="currentStep === 1" class="form-step">
            <div class="form-row">
              <div class="select-wrapper">
                <select class="form-control" 
                        name="appType" 
                        [(ngModel)]="formData.appType" 
                        required>
                  <option value="" disabled selected>Type d'application</option>
                  <option *ngFor="let option of appTypeOptions" [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>
              
              <div class="select-wrapper">
                <select class="form-control" 
                        name="complexity" 
                        [(ngModel)]="formData.complexity">
                  <option value="" disabled selected>Complexité</option>
                  <option *ngFor="let option of complexityOptions" [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>
            </div>
            
            <div class="form-row">
              <div class="select-wrapper">
                <select class="form-control" 
                        name="timeline" 
                        [(ngModel)]="formData.timeline">
                  <option value="" disabled selected>Délai souhaité</option>
                  <option *ngFor="let option of timelineOptions" [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>
              
              <div class="select-wrapper">
                <select class="form-control" 
                        name="budget" 
                        [(ngModel)]="formData.budget">
                  <option value="" disabled selected>Budget</option>
                  <option *ngFor="let option of budgetOptions" [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>
            </div>
            
            <button type="button" 
                    class="suivant-button" 
                    (click)="nextStep()" 
                    [disabled]="!isStep1Valid()">
              Suivant
            </button>
          </div>

          <!-- Step 2: Project Details -->
          <div *ngIf="currentStep === 2" class="form-step">
            <input type="text" 
                   class="form-control" 
                   placeholder="Nom du projet" 
                   name="projectName" 
                   [(ngModel)]="formData.projectName" 
                   required>
            
            <textarea class="form-control textarea" 
                      placeholder="Décrivez votre projet d'application en détail" 
                      name="description" 
                      [(ngModel)]="formData.description" 
                      rows="6" 
                      required></textarea>
            
            <div class="form-navigation">
              <button type="button" class="prev-button" (click)="previousStep()">
                Précédent
              </button>
              <button type="button" 
                      class="suivant-button" 
                      (click)="nextStep()" 
                      [disabled]="!isStep2Valid()">
                Suivant
              </button>
            </div>
          </div>

          <!-- Step 3: Contact Info -->
          <div *ngIf="currentStep === 3" class="form-step">
            <div class="form-row">
              <input type="text" 
                     class="form-control" 
                     placeholder="Nom et Prénom" 
                     name="name" 
                     [(ngModel)]="formData.name" 
                     required>
              <input type="email" 
                     class="form-control" 
                     placeholder="Email" 
                     name="email" 
                     [(ngModel)]="formData.email" 
                     required 
                     email>
            </div>
            
            <div class="form-row">
              <input type="text" 
                     class="form-control" 
                     placeholder="Entreprise" 
                     name="company" 
                     [(ngModel)]="formData.company">
            </div>
            
            <div class="phone-row">
              <select class="country-code-select" 
                      name="countryCode" 
                      [(ngModel)]="formData.countryCode">
                <option value="+33">🇫🇷 +33</option>
                <option value="+212">🇲🇦 +212</option>
              </select>
              <input type="tel" 
                     class="form-control phone-input" 
                     placeholder="Téléphone" 
                     name="phone" 
                     [(ngModel)]="formData.phone"
                     required>
            </div>
            
            <label class="terms-checkbox">
              <input type="checkbox" 
                     name="acceptTerms" 
                     [(ngModel)]="formData.acceptTerms" 
                     required>
              <span class="checkmark"></span>
              En cochant cette case, vous acceptez notre <span class="link-text">Politique de Confidentialité</span> et <span class="link-text">Conditions Générales d'Utilisation</span>.
            </label>
            
            <div class="form-navigation">
              <button type="button" class="prev-button" (click)="previousStep()">
                Précédent
              </button>
              <button type="submit" 
                      class="suivant-button"
                      [disabled]="!isStep3Valid() || isSubmitting"
                      [class.button-loading]="isSubmitting">
                <span *ngIf="!isSubmitting">Envoyer la demande</span>
                <span *ngIf="isSubmitting" class="loading-spinner">Envoi en cours...</span>
              </button>
            </div>
          </div>
          
        </form>
        
        <!-- Success State - Show after form submission -->
        <div *ngIf="submissionSuccess" class="success-state">
          <div class="success-content">
            <div class="success-icon-large">✓</div>
            <h3>Merci pour votre demande!</h3>
            <p>Nous avons bien reçu votre demande de devis et nous vous contacterons dans les 24 heures.</p>
            <button type="button" class="suivant-button" (click)="resetForm()">
              Nouvelle demande
            </button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</section>

<!-- Features Showcase Section -->
<section class="features-showcase-section">
  <div class="container">
    
    <!-- Section Header -->
    <div class="section-header">
      <h2>Nos Services de Développement d'Applications</h2>
      <p class="section-subtitle">Des solutions complètes pour transformer vos idées en applications performantes</p>
      <div class="header-decoration"></div>
    </div>
    
    <!-- Feature 1 - Mobile Development -->
    <div class="feature-showcase feature-mobile">
      <div class="feature-content">
        <div class="feature-badge">
          <span class="badge-icon">📱</span>
          <span class="badge-text">Développement Mobile</span>
        </div>
        <h3>Applications Mobiles Natives & Hybrides</h3>
        <p>Créez des applications iOS et Android performantes avec une expérience utilisateur exceptionnelle, optimisées pour chaque plateforme.</p>
        
        <div class="feature-highlights">
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Applications iOS natives en Swift</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Applications Android en Kotlin/Java</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Solutions hybrides React Native/Flutter</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Interface utilisateur moderne et intuitive</span>
          </div>
        </div>
        
        <div class="feature-stats">
          <div class="stat-item">
            <span class="stat-number">200+</span>
            <span class="stat-label">Apps Développées</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">99%</span>
            <span class="stat-label">Taux de Satisfaction</span>
          </div>
        </div>
      </div>
      
      <div class="feature-visual">
        <div class="visual-container">
          <div class="floating-card">
            <div class="app-mockup">
              <div class="phone-frame">
                <div class="phone-screen">
                  <div class="app-icon">📱</div>
                  <div class="app-title">Mon Application</div>
                  <div class="app-buttons">
                    <div class="app-button">Accueil</div>
                    <div class="app-button">Profil</div>
                    <div class="app-button">Paramètres</div>
                    <div class="app-button">Contact</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="glow-effect"></div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Feature 2 - Web Applications -->
    <div class="feature-showcase feature-strategy">
      <div class="feature-visual">
        <div class="visual-container">
          <div class="floating-card">
            <div class="app-mockup">
              <div class="laptop-frame">
                <div class="laptop-screen">
                  <div class="web-header">
                    <div class="web-dot" style="background: #ff5f56;"></div>
                    <div class="web-dot" style="background: #ffbd2e;"></div>
                    <div class="web-dot" style="background: #27ca3f;"></div>
                  </div>
                  <div class="web-content">
                    <div class="web-title">Application Web Moderne</div>
                    <div class="web-elements">
                      <div class="web-element"></div>
                      <div class="web-element"></div>
                      <div class="web-element"></div>
                      <div class="web-element"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="glow-effect"></div>
          </div>
        </div>
      </div>
      
      <div class="feature-content">
        <div class="feature-badge purple">
          <span class="badge-icon">💻</span>
          <span class="badge-text">Applications Web</span>
        </div>
        <h3>Applications Web Performantes</h3>
        <p>Développement d'applications web modernes et réactives avec les dernières technologies pour une expérience utilisateur optimale.</p>
        
        <div class="feature-highlights">
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Progressive Web Apps (PWA)</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Applications Single Page (SPA)</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Technologies modernes (React, Angular, Vue)</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Design responsive et adaptatif</span>
          </div>
        </div>
        
        <div class="feature-stats">
          <div class="stat-item">
            <span class="stat-number">150+</span>
            <span class="stat-label">Apps Web</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">24/7</span>
            <span class="stat-label">Support</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Feature 3 - E-commerce & Business Apps -->
    <div class="feature-showcase feature-ecommerce">
      <div class="feature-content">
        <div class="feature-badge orange">
          <span class="badge-icon">🛒</span>
          <span class="badge-text">E-commerce & Business</span>
        </div>
        <h3>Solutions E-commerce & Métier</h3>
        <p>Développement d'applications e-commerce et métier sur mesure pour digitaliser et optimiser vos processus business.</p>
        
        <div class="feature-highlights">
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Boutiques en ligne complètes</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Systèmes de gestion métier (CRM, ERP)</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Paiement sécurisé intégré</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Tableaux de bord et analytics</span>
          </div>
        </div>
        
        <div class="feature-stats">
          <div class="stat-item">
            <span class="stat-number">+300%</span>
            <span class="stat-label">ROI Moyen</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">95%</span>
            <span class="stat-label">Uptime</span>
          </div>
        </div>
      </div>
      
      <div class="feature-visual">
        <div class="visual-container">
          <div class="floating-card">
            <div class="app-mockup">
              <div class="dashboard-frame">
                <div class="dashboard-content">
                  <div class="dashboard-header">Tableau de Bord</div>
                  <div class="dashboard-stats">
                    <div class="stat-card">
                      <div class="stat-value">1.2K</div>
                      <div class="stat-label">VENTES</div>
                    </div>
                    <div class="stat-card">
                      <div class="stat-value">85%</div>
                      <div class="stat-label">CONVERSION</div>
                    </div>
                  </div>
                  <div class="dashboard-chart">
                    <div class="chart-bar" style="height: 60%;"></div>
                    <div class="chart-bar" style="height: 80%;"></div>
                    <div class="chart-bar" style="height: 40%;"></div>
                    <div class="chart-bar" style="height: 90%;"></div>
                    <div class="chart-bar" style="height: 70%;"></div>
                    <div class="chart-bar" style="height: 85%;"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="glow-effect"></div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Call to Action -->
    <div class="section-cta">
      <div class="cta-content">
        <h3>Prêt à Développer Votre Application ?</h3>
        <p>Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé</p>
        <button class="cta-button-main" (click)="scrollToForm()">
          <span>Demander un Devis</span>
          <div class="button-arrow">→</div>
        </button>
      </div>
    </div>
    
  </div>
</section>

<!-- Technology Stack Section -->
<section class="tech-stack-section">
  <div class="container">
    <div class="tech-header">
      <h2>Technologies & Frameworks Utilisés</h2>
      <p class="tech-subtitle">Nous utilisons les dernières technologies pour créer des applications performantes et évolutives</p>
    </div>
    
    <div class="tech-categories">
      <!-- Mobile Technologies -->
      <div class="tech-category">
        <div class="category-header">
          <div class="category-icon">📱</div>
          <h3>Développement Mobile</h3>
        </div>
        <div class="tech-grid">
          <div class="tech-item" *ngFor="let tech of getTechStack().mobile">
            <div class="tech-logo" [ngStyle]="{'background': tech.color}">
              <span>{{ tech.tech }}</span>
            </div>
            <span class="tech-name">{{ tech.name }}</span>
          </div>
        </div>
      </div>

      <!-- Web Technologies -->
      <div class="tech-category">
        <div class="category-header">
          <div class="category-icon">🌐</div>
          <h3>Développement Web</h3>
        </div>
        <div class="tech-grid">
          <div class="tech-item" *ngFor="let tech of getTechStack().web">
            <div class="tech-logo" [ngStyle]="{'background': tech.color}">
              <span>{{ tech.tech }}</span>
            </div>
            <span class="tech-name">{{ tech.name }}</span>
          </div>
        </div>
      </div>

      <!-- Backend Technologies -->
      <div class="tech-category">
        <div class="category-header">
          <div class="category-icon">⚙️</div>
          <h3>Backend & API</h3>
        </div>
        <div class="tech-grid">
          <div class="tech-item" *ngFor="let tech of getTechStack().backend">
            <div class="tech-logo" [ngStyle]="{'background': tech.color}">
              <span>{{ tech.tech }}</span>
            </div>
            <span class="tech-name">{{ tech.name }}</span>
          </div>
        </div>
      </div>

      <!-- Databases -->
      <div class="tech-category">
        <div class="category-header">
          <div class="category-icon">🗄️</div>
          <h3>Bases de Données</h3>
        </div>
        <div class="tech-grid">
          <div class="tech-item" *ngFor="let tech of getTechStack().database">
            <div class="tech-logo" [ngStyle]="{'background': tech.color}">
              <span>{{ tech.tech }}</span>
            </div>
            <span class="tech-name">{{ tech.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Process Section -->
<section class="process-section">
  <div class="container">
    <div class="process-header">
      <h2>Notre Processus de Développement</h2>
      <p class="process-subtitle">Une méthodologie éprouvée pour garantir le succès de votre projet</p>
    </div>
    
    <div class="process-timeline">
      <div class="process-step" *ngFor="let step of getDevelopmentProcess()">
        <div class="step-number">{{ step.number }}</div>
        <div class="step-content">
          <div class="step-icon">{{ step.icon }}</div>
          <h3>{{ step.title }}</h3>
          <p>{{ step.description }}</p>
          <div class="step-duration">{{ step.duration }}</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Pricing Section -->
<section class="pricing-section">
  <div class="container">
    <div class="pricing-header">
      <h2>Tarifs Développement d'Applications</h2>
      <p class="pricing-subtitle">Des forfaits adaptés à tous les projets et budgets</p>
    </div>
    
    <div class="pricing-grid">
      <div class="pricing-card" 
           *ngFor="let plan of getPricingPlans()" 
           [class.pro-card]="plan.isPopular">
        
        <div class="popular-badge" *ngIf="plan.isPopular">LE PLUS POPULAIRE</div>
        
        <div class="card-header">
          <h3 class="plan-name">{{ plan.name }}</h3>
          <p class="plan-subtitle">{{ plan.subtitle }}</p>
          <div class="plan-badge" [class]="plan.buttonClass.replace('-button', '-badge')">{{ plan.badge }}</div>
        </div>
        
       <!-- <div class="card-pricing">
           <div class="old-price">{{ plan.oldPrice }}</div> 
          <div class="price-label">À PARTIR DE</div>
          <div class="current-price">{{ plan.currentPrice }}</div>
        </div>-->
        
        <div class="card-features">
          <div class="feature-item" *ngFor="let feature of plan.features">
            <span class="check-icon">✓</span>
            <span>{{ feature }}</span>
          </div>
        </div>
        
        <button class="cta-button" [class]="plan.buttonClass" (click)="scrollToForm()">
          <span>Demander un devis</span>
        </button>
      </div>
    </div>
  </div>
</section>

<footer class="footer-section">
  <div class="footer-container">
    
    <!-- Main Footer Content -->
    <div class="footer-content">
      
      <!-- Section 1: Company Logo & Description -->
      <div class="footer-company">
        <div class="company-logo">
          <img src="assets/images/logo-white.png" alt="Rhillane Logo" />
        </div>
        
        <p class="company-description">
          Digital Alchemy, votre partenaire de confiance pour la création de sites web . 
          Nous transformons vos idées en succès digital avec des solutions innovantes et performantes.
        </p>
        
        <!-- Social Media -->
        <div class="social-media-section">
          <ul style="display: flex; gap: 16px; list-style: none; padding: 0; margin: 0;">
            
            <!-- Facebook -->
            <li style="margin: 0;">
              <a href="https://www.facebook.com/people/Digital-alchemy/61565618420833" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Facebook page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1877F2; fill: #1877F2;" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </li>
            
            <!-- Behance -->
            <li style="margin: 0;">
              <a href="https://www.behance.net/digitalalchemy2" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Behance page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1769FF; fill: #1769FF;" viewBox="0 0 24 24">
                  <path d="M0 4.4804V19.243h7.1554c.6613 0 1.3078-.0832 1.9297-.248.6288-.1654 1.1905-.4203 1.6792-.7661.485-.3431.8784-.7804 1.1677-1.3081.2862-.5258.4294-1.1471.4294-1.8641 0-.8784-.2067-1.6309-.6172-2.2506-.4073-.6172-.9897-1.0907-1.7494-1.4161.6388-.3431 1.1139-.8141 1.4285-1.4143.3146-.6002.4719-1.2755.4719-2.0274 0-.7193-.1327-1.3487-.4-1.8888-.2668-.5402-.6343-1.0033-1.0995-1.3914-.4652-.3881-.9712-.6884-1.5186-.8999C8.8135 4.5932 8.2071 4.4804 7.5446 4.4804H0zM15.3486 6.9795h4.7992v1.2755h-4.7992V6.9795zM3.2695 6.9795h3.8893c.9451 0 1.6612.2262 2.1463.6787.4851.4525.7277 1.0632.7277 1.8321 0 .8374-.2768 1.4676-.8323 1.8888-.5555.4212-1.2925.6323-2.2091.6323H3.2695V6.9795zM15.3486 13.2363h4.7992v1.2755h-4.7992v-1.2755zM3.2695 14.2834h4.3172c.6927 0 1.2944.1327 1.8051.3976.5107.2649.9378.6154 1.2755 1.0519.3377.4365.5849.9378.741 1.5044.1561.5666.2342 1.1543.2342 1.7632 0 .7193-.1014 1.3487-.3043 1.8888-.2029.5401-.5107.9949-.9237 1.3648-.4131.3699-.9378.6507-1.5743.8409-.6365.1902-1.3858.2853-2.2477.2853H3.2695v-7.0969z"/>
                </svg>
              </a>
            </li>
            
            <!-- LinkedIn -->
            <li style="margin: 0;">
              <a href="https://www.linkedin.com/company/digital-alchemy-ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our LinkedIn page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #0077B5; fill: #0077B5;" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </li>
            
            <!-- YouTube -->
            <li style="margin: 0;">
              <a href="https://www.youtube.com/@Digital_Alchemy_ma" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our YouTube page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #FF0000; fill: #FF0000;" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </li>
            
            <!-- Instagram -->
            <li style="margin: 0;">
              <a href="https://www.instagram.com/digital_alchemy_ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Instagram page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #E1306C; fill: #E1306C;" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </li>
            
          </ul>
        </div>
      </div>
      
      <!-- Section 2: Contact Information -->
      <div class="footer-contact">
        <h3 class="footer-title">CONTACT</h3>
        
        <div class="contact-info">
          <div class="contact-item">
            <span>+212 690 459 525</span>
          </div>
          <div class="contact-item">
            <span>+33 6 66 07 64 55</span>
          </div>
          <div class="contact-item">
            <span>Digitalalchemyma&#64;gmail.com</span>
          </div>
          <div class="contact-item">
            <span>Contact&#64;digalchemy.com</span>
          </div>
        </div>
        
        <div class="office-locations">
          <div class="office-item">
            <h4>NOTRE BUREAU AU MAROC</h4>
            <p>Bd Dammam, Technopark Casablanca , Maroc .</p>
          </div>
        </div>
      </div>
      
      <!-- Section 3: Services Column -->
      <div class="footer-links">
        <h3 class="footer-title">NOS SERVICES</h3>
        <ul class="footer-list">
          <li><a routerLink="/web">Sites Web</a></li>
          <li><a routerLink="/appweb">Application Web</a></li>
          <li><a routerLink="/publicite">Publicité en ligne</a></li>
          <li><a routerLink="/gestion">Gestion des réseaux sociaux</a></li>
          <li><a routerLink="/design">Design Graphique</a></li>
          <li><a routerLink="/agence">Agence SEO</a></li>
        </ul>
      </div>
      
      <!-- Section 4: Quick Links Column -->
      <div class="footer-links">
        <h3 class="footer-title">LIENS RAPIDES</h3>
        <ul class="footer-list">
          <li><a routerLink="/">Accueil</a></li>
          <li><a routerLink="/apropos">À propos</a></li>
          <li><a routerLink="/contact">Contact</a></li>
          <li><a routerLink="/cgu">Conditions Générales d'Utilisation</a></li>
          <li><a routerLink="/conf">Politique de Confidentialité</a></li>
        </ul>
      </div>
      
    </div>
    
    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <p class="copyright">
          © {{ currentYear }} Digital Alchemy. Tous droits réservés. | 
          <a routerLink="/cgu">Mentions légales</a> | 
          <a routerLink="/conf">Politique des cookies</a>
        </p>
        <div class="footer-bottom-links">
          <a routerLink="/contact">Support</a>
        </div>
      </div>
    </div>
    
  </div>
</footer>